import {
    FETCH_GROUPS_REQUEST,
    FETCH_GROUPS_SUCCESS,
    FETCH_GROUPS_FAILURE,
    CREATE_GROUP_REQUEST,
    CREATE_GROUP_SUCCESS,
    CREATE_GROUP_FAILURE
  } from '../actions/groupActions';
  
  const initialState = {
    groups: [],
    loading: false,
    error: null,
  };
  
  const groupReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_GROUPS_REQUEST:
        return { ...state, loading: true, error: null };
      case FETCH_GROUPS_SUCCESS:
        return { ...state, loading: false, groups: action.payload };
      case FETCH_GROUPS_FAILURE:
        return { ...state, loading: false, error: action.payload };
      case CREATE_GROUP_REQUEST:
        return { ...state, loading: true };
      case CREATE_GROUP_SUCCESS:
        return { ...state, loading: false, groups: [...state.groups, action.payload] };
      case CREATE_GROUP_FAILURE:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  
  export default groupReducer;
  